<template>
    <div>
        <template slot="title">
            {{ varObj.optType }}服务
        </template>
        <div v-if="varObj.optBool" v-loading="contentLoading" class="content">
            <hc-form ref="form" label-position="left" label-width="112px" :model="apiParamObj" :rules="rulesObj">
                <div v-if="!isNotXingTuApi" class="deploy-service-box">
                    <h1>
                        基本信息
                    </h1>
                    <div class="row">
                        <hc-form-item v-if="!isNotXingTuApi" key="api" label="集成开放平台API" prop="api">
                            <hc-select v-model="apiParamObj.api" filterable placeholder="请选择集成开放平台API">
                                <hc-option v-for="item in mipApiList" :key="item.apiId" :label="item.apiName" :value="item.apiId" />
                            </hc-select>
                        </hc-form-item>
                        <hc-form-item v-if="!isOffline" label="请求路径" prop="url" class="multiple-form-item">
                            <hc-input
                                v-model.trim="apiParamObj.url"
                                :disabled="!isNotXingTuApi || (isTenantApp && !apiParamObj.isTenant)"
                                type="text"
                                :placeholder="apiParamObj.isXingTu ? '请先选择集成开放平台API' : (apiParamObj.domainVariableKey ? '请输入相对路径' : '请输入请求的URL地址')"
                                size="small"
                            />
                        </hc-form-item>
                    </div>

                    <div class="row">
                        <hc-form-item v-if="!isOffline" label="请求方法" prop="method">
                            <hc-radio-group
                                v-model.trim="apiParamObj.method"
                                :disabled="!isNotXingTuApi || (isTenantApp && !apiParamObj.isTenant)"
                                placeholder="请选择请求方法"
                                size="small"
                            >
                                <hc-radio key="get" label="get">
                                    Get
                                </hc-radio>
                                <hc-radio key="post" label="post">
                                    Post
                                </hc-radio>
                                <hc-radio v-if="!isNotXingTuApi" key="put" label="put" value="put">
                                    Put
                                </hc-radio>
                                <hc-radio v-if="!isNotXingTuApi" key="delete" label="delete" value="delete">
                                    Delete
                                </hc-radio>
                            </hc-radio-group>
                        </hc-form-item>

                        <hc-form-item v-if="!isNotXingTuApi" label="是否认证">
                            <hc-input
                                :value="!apiParamObj.api ? '' : (apiParamObj.hasAuth ? (apiParamObj.authType || '需要认证') : '无认证')"
                                :disabled="!isNotXingTuApi || (isTenantApp && !apiParamObj.isTenant)"
                                type="text"
                                :placeholder="!apiParamObj.api ? '请先选择集成开放平台API' : ''"
                                size="small"
                            />
                        </hc-form-item>
                    </div>

                    <div class="row">
                        <hc-form-item label="备注信息" prop="remark" class="service-remark block">
                            <hc-input
                                v-model.trim="apiParamObj.remark"
                                :disabled="!isNotXingTuApi || (isTenantApp && !apiParamObj.isTenant)"
                                type="textarea"
                                rows="3"
                                :placeholder="!apiParamObj.api ? '请先选择集成开放平台API':''"
                            />
                        </hc-form-item>
                    </div>

                    <div class="row">
                        <hc-form-item label="服务名称" prop="name">
                            <hc-input
                                v-model.trim="apiParamObj.name"
                                :disabled="!isNotXingTuApi && !apiParamObj.api || (isTenantApp && !apiParamObj.isTenant)"
                                type="text"
                                placeholder="请求path自动生成"
                                size="small"
                                @focus="handleAutoGenCode"
                            >
                                <template v-if="isTenantApp && apiParamObj.isTenant" slot="append">
                                    {{ COMMON_APPEND }}
                                </template>
                            </hc-input>
                        </hc-form-item>

                        <hc-form-item label="所属分组" prop="groupId">
                            <hc-select v-model.trim="apiParamObj.groupId" placeholder="请选择" size="small" :disabled="(isTenantApp && !apiParamObj.isTenant)">
                                <hc-option v-for="item in groupArr" :key="item.id" :label="item.title" :value="item.id">
                                    <p>{{ item.title }}</p>
                                </hc-option>
                                <div v-if="!isTenantApp" :style="{ height: showAddgroup ? '84px' : '44px' }" />
                                <div v-if="!isTenantApp" class="add_group">
                                    <hc-row v-if="showAddgroup" type="flex">
                                        <hc-col :span="17" class="add_item">
                                            <hc-input
                                                v-model="addInput"
                                                placeholder="请输入分组名"
                                                style="width: 100%"
                                                @keyup.enter.native="addGroupbySelect"
                                                @input="(val)=>{ addInput = val.replace(groupNameReg,'')}"
                                            />
                                        </hc-col>
                                        <hc-col :span="7">
                                            <hc-button type="text" class="onAddSave" style="margin-left: 12px" @click="addGroupbySelect">
                                                保存
                                            </hc-button>
                                            <hc-button type="text" @click="showAddgroup = false">
                                                取消
                                            </hc-button>
                                        </hc-col>
                                    </hc-row>
                                    <hc-button
                                        icon="hc-icon-plus"
                                        type="text"
                                        @click="
                                            showAddgroup = true
                                            addInput = ''
                                        "
                                    >
                                        新增分组
                                    </hc-button>
                                </div>
                            </hc-select>
                        </hc-form-item>
                    </div>
                </div>
                <div v-else class="deploy-service-box">
                    <h1>
                        基本信息
                    </h1>
                    <div class="row">
                        <hc-form-item v-if="!isNotXingTuApi" key="api" label="选择API" prop="api">
                            <hc-select v-model="apiParamObj.api" filterable placeholder="请选择API">
                                <hc-option v-for="item in mipApiList" :key="item.apiId" :label="item.apiName" :value="item.apiId" />
                            </hc-select>
                        </hc-form-item>
                        <hc-form-item label="显示名称" prop="title">
                            <hc-input
                                v-model.trim="apiParamObj.title"
                                :disabled="!isNotXingTuApi || (isTenantApp && !apiParamObj.isTenant)"
                                type="text"
                                placeholder="请输入显示名称"
                                size="small"
                            />
                        </hc-form-item>
                        <hc-form-item label="服务名称" prop="name">
                            <hc-input
                                v-model.trim="apiParamObj.name"
                                :disabled="!isNotXingTuApi && !apiParamObj.api || (isTenantApp && !apiParamObj.isTenant)"
                                type="text"
                                placeholder="请输入服务名称"
                                size="small"
                                @focus="handleAutoGenCode"
                            >
                                <template v-if="isTenantApp && apiParamObj.isTenant" slot="append">
                                    {{ COMMON_APPEND }}
                                </template>
                            </hc-input>
                        </hc-form-item>
                    </div>

                    <div class="row">
                        <hc-form-item label="所属分组" prop="groupId">
                            <hc-select v-model.trim="apiParamObj.groupId" placeholder="请选择" size="small" :disabled="(isTenantApp && !apiParamObj.isTenant)">
                                <hc-option v-for="item in groupArr" :key="item.id" :label="item.title" :value="item.id">
                                    <p>{{ item.title }}</p>
                                </hc-option>
                                <div v-if="!isTenantApp" :style="{ height: showAddgroup ? '84px' : '44px' }" />
                                <div v-if="!isTenantApp" class="add_group">
                                    <hc-row v-if="showAddgroup" type="flex">
                                        <hc-col :span="17" class="add_item">
                                            <hc-input
                                                v-model="addInput"
                                                placeholder="请输入分组名"
                                                style="width: 100%"
                                                @keyup.enter.native="addGroupbySelect"
                                                @input="(val)=>{ addInput = val.replace(groupNameReg,'')}"
                                            />
                                        </hc-col>
                                        <hc-col :span="7">
                                            <hc-button type="text" class="onAddSave" style="margin-left: 12px" @click="addGroupbySelect">
                                                保存
                                            </hc-button>
                                            <hc-button type="text" @click="showAddgroup = false">
                                                取消
                                            </hc-button>
                                        </hc-col>
                                    </hc-row>
                                    <hc-button
                                        icon="hc-icon-plus"
                                        type="text"
                                        @click="
                                            showAddgroup = true
                                            addInput = ''
                                        "
                                    >
                                        新增分组
                                    </hc-button>
                                </div>
                            </hc-select>
                        </hc-form-item>
                        <hc-form-item v-if="!isOffline" label="API地址" prop="url" class="multiple-form-item">
                            <hc-select v-if="isNotXingTuApi" v-model="apiParamObj.domainVariableKey" :title="apiParamObj.domainVariableKey">
                                <hc-option key="_empty_" label="不使用环境变量" value="" />
                                <hc-option v-for="item in variables" :key="item.variableKey" :label="item.variableKey" :value="item.variableKey" />
                            </hc-select>
                            <hc-input
                                ref="urlInput"
                                v-model.trim="apiParamObj.url"
                                :disabled="!isNotXingTuApi || (isTenantApp && !apiParamObj.isTenant)"
                                type="text"
                                :placeholder="apiParamObj.isXingTu ? '请输入API地址' : (apiParamObj.domainVariableKey ? '请输入相对路径' : '请输入请求的URL地址')"
                                size="small"
                            />
                        </hc-form-item>
                    </div>

                    <div class="row">
                        <hc-form-item v-if="!isOffline" label="请求方法" prop="method">
                            <hc-radio-group
                                v-model.trim="apiParamObj.method"
                                :disabled="!isNotXingTuApi || (isTenantApp && !apiParamObj.isTenant)"
                                placeholder="请选择请求方法"
                                size="small"
                            >
                                <hc-radio key="get" label="get">
                                    Get
                                </hc-radio>
                                <hc-radio key="post" label="post">
                                    Post
                                </hc-radio>
                                <hc-radio key="put" label="put" value="put">
                                    Put
                                </hc-radio>
                                <hc-radio key="delete" label="delete" value="delete">
                                    Delete
                                </hc-radio>
                            </hc-radio-group>
                        </hc-form-item>

                        <hc-form-item v-if="!isNotXingTuApi" label="是否认证">
                            <span v-if="!apiParamObj.api">--</span>
                            <span v-else>{{ apiParamObj.hasAuth ? '是' : '否' }}</span>
                        </hc-form-item>
                    </div>

                    <div class="row">
                        <hc-form-item style="margin-bottom: 0" label="备注信息" prop="remark" class="service-remark block">
                            <hc-input
                                v-model.trim="apiParamObj.remark"
                                :disabled="!isNotXingTuApi || (isTenantApp && !apiParamObj.isTenant)"
                                type="textarea"
                                rows="3"
                                placeholder="请输入备注信息"
                            />
                        </hc-form-item>
                    </div>
                </div>

                <offline-service-params
                    v-if="isOffline"
                    ref="offlineServiceParams"
                    :var-obj="varObj"
                    :business-env-id="businessEnvId"
                    :is-not-xing-tu-api="isNotXingTuApi"
                    :rules-obj="rulesObj"
                    :api-param-obj="apiParamObj"
                    @load-starMap-start="contentLoading = true"
                    @load-starMap-end="contentLoading = false"
                    @change-api-param="onChangeApiParam"
                    @change-temp-param="onChangeTempParam"
                />
                <custom-service-params
                    v-else-if="isNotXingTuApi"
                    ref="customServiceParams"
                    :var-obj="varObj"
                    :business-env-id="businessEnvId"
                    :is-not-xing-tu-api="isNotXingTuApi"
                    :rules-obj="rulesObj"
                    :api-param-obj="apiParamObj"
                    @load-starMap-start="contentLoading = true"
                    @load-starMap-end="contentLoading = false"
                    @change-api-param="onChangeApiParam"
                    @change-temp-param="onChangeTempParam"
                    @change-temp-body="onChangeTempBody"
                />
                <platform-service-params
                    v-else
                    ref="platformServiceParams"
                    :var-obj="varObj"
                    :business-env-id="businessEnvId"
                    :mip-api-detail="mipApiDetail"
                    :api-param-obj="apiParamObj"
                    :is-not-xing-tu-api="isNotXingTuApi"
                />
            </hc-form>
        </div>
        <div slot="footer">
            <div class="footer">
                <hc-button
                    :type="varObj.optType === '编辑' ? 'primary' : 'primary'"
                    :disabled="isTenantApp ?
                        varObj.optType === '添加' ?
                            !validPurviewService.addService : apiParamObj.isTenant ? false : !validPurviewService.updateService
                        : false"
                    @click="varObj.optType === '添加' ? add() : edit()"
                >
                    保存
                </hc-button>
                <hc-button type="plain" @click="back">
                    取消
                </hc-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import { logger } from '@mypaas/app-render-engine/core/sdk'
import * as T from '@common/store/app-resource/types'
import { APP_RESOURCE, STAR_MAP } from '@common/store/module-types'
import {
    GET_MIP_API_DETAIL,
    GET_MIP_API_LIST,
    GET_STAR_MAP_BINDING_DETAIL,
} from '@common/store/star-map/types'
import characterLength from '@common/utils/character-length'
import { apiRegex, FIELD_MID_REGEXP } from '@common/utils/regExp'
import { getFormsValidRes } from '@common/utils/formValidToPromise'
import CustomServiceParams from './custom-service-params'
import PlatformServiceParams from './platform-service-params'
import OfflineServiceParams from './offline-service-params'
import { fieldTransform, isParamsType } from '../service/service-management'

import commomMixin from '../mixins/commom'

let TMP_API_OBJ = []
let TMP_API_BODY = []
const validateCnName = (rule, value, callback) => {
    if (value.length > 50) {
        callback(new Error('最大长度不能超过50个字符'))
        return
    }
    callback()
}
const validateApiLength = (rule, value, callback) => {
    if (characterLength(value) > 255) {
        callback(new Error('最大长度不能超过255个字符'))
        return
    }
    callback()
}
const validateApi = (rule, value, callback) => {
    if (!apiRegex.test(value)) {
        callback(new Error('请输入正确的api格式'))
        return
    }
    callback()
}
const validateField = (rule, value, callback) => {
    if (!FIELD_MID_REGEXP.test(value)) {
        callback(new Error('请输入英文、数字、下划线、中划线，英文字母开头，不以下划线结尾，且不包含2个连续下划线'))
        return
    }
    callback()
}

const validateKey = (rule, value, callback) => {
    const { fullField } = rule
    const arr = fullField.split('.')
    const formType = arr[0]
    const index = Number(arr[1])

    const target = formType.startsWith('tableDataArr') ? TMP_API_OBJ : TMP_API_BODY
    const origin = target[index]
    const { key, paramType } = origin

    if (!key) {
        callback(new Error('请输入名称'))
        return
    }
    const hasSameValue = target
        .filter(item => item.paramType === paramType && item.key === value)
        .map(item => item.index)
    if (hasSameValue.length > 1) {
        if (Math.max(...hasSameValue) === index) {
            callback(new Error('位置相同的参数名称不能重复'))
        }
        return
    }
    callback()
}

const getRulesObj = customRule => {
    const rules = {
        title: [
            {
                required: true,
                message: '请输入显示名称',
                trigger: 'blur',
            },
            { validator: validateCnName, trigger: 'blur' },
        ],
        name: [
            {
                required: true,
                message: '请输入服务名称',
                trigger: 'blur',
            },
            { validator: validateCnName, trigger: 'blur' },
            { validator: validateField, trigger: 'blur' },
        ],
        url: [
            {
                required: true,
                message: '请输入API地址',
                trigger: 'blur',
            },
            { validator: validateApiLength, trigger: 'blur' },
            { validator: validateApi, trigger: 'blur' },
        ],

        key: [
            {
                required: true,
                validator: validateKey,
                trigger: ['blur', 'change'],
            },
        ],
        type: [
            {
                required: true,
                message: '请选择值类型',
                trigger: 'change',
            },
        ],
        required: [
            {
                required: true,
                message: '请选择是否必填',
                trigger: 'change',
            },
        ],
        value: [
            {
                required: true,
                message: '请输入Value',
                trigger: 'blur',
            },
        ],
        groupId: [
            {
                required: true,
                message: '请选择分组',
                trigger: ['blur', 'change'],
            },
        ],
        api: [
            {
                required: true,
                message: '请选择API',
                trigger: 'blur',
            },
        ],
    }
    if (!customRule) return rules
    Object.entries(customRule).forEach(([key, value]) => {
        rules[key] = rules[key] || []
        rules[key].push(...(Array.isArray(value) ? value : [value]))
    })

    return rules
}

const COMMON_APPEND = '__c'

export default {
    name: 'DeployService',
    components: {
        CustomServiceParams,
        PlatformServiceParams,
        OfflineServiceParams,
    },
    mixins: [commomMixin],
    props: {
        varObj: {
            type: Object,
            require: true,
        },
        apiParamObj: {
            type: Object,
            require: true,
        },
        appId: {
            type: String,
            require: true,
        },
        loading: {
            type: Object,
            require: true,
        },
        groupArr: {
            type: Array,
            require: true,
        },
        businessEnvId: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            COMMON_APPEND,
            slideModalVisible: false,
            rulesObj: getRulesObj({
                url: {
                    validator: this.validateApiDomainVar,
                    trigger: 'blur',
                },
            }),
            // 请求接口的参数
            tableFormObj: {
                tableDataArr: [],
            },
            addInput: '',
            showAddgroup: false,
            apiSelectstyles: {
                height: '32px',
            },
            contentLoading: false,
            apiSelectParams: {
                placeholder: '请选择API',
            },
            groupNameReg: /[^\u4E00-\u9FA5A-Za-z_]/g,
            mipApiDetail: {},
            cacheData: {
                customCreated: undefined,
                starMap: undefined,
            },
            hasBindingStarMap: true,
            apiTreeParams: {
                clickParent: false,
                filterable: true,
                'check-strictly': true,
                'default-expand-all': true,
                'expand-on-click-node': false,
                data: [],
                props: {
                    children: 'child',
                    label: 'name',
                    value: 'id',
                },
            },
            editLoading: false,
        }
    },
    computed: {
        ...mapGetters(STAR_MAP, ['mipApiList']),
        current() {
            return this.$store.state.WORKSPACE.current || {}
        },
        isNotXingTuApi() {
            return !this.apiParamObj.isXingTu
        },
        isOffline() {
            return this.apiParamObj.isOffline
        },
        currentRef() {
            return this.isOffline ? 'offlineServiceParams' : this.isNotXingTuApi ? 'customServiceParams' : 'platformServiceParams'
        },
        isTenantApp() {
            return this.$store.state.modeling.app.isTenant
        },
        appInfo() {
            return this.$store.state.modeling.app
        },
        validPurviewService() {
            return this.$store.state.modeling.validPurview.service || {}
        },
        xingTuEnvId() {
            return (this.current.xingtuInfo || {}).xingTuEnvId || ''
        },
        xingtuEnable() {
            // 是否开启集成开放平台且分支绑定了集成开放平台
            return this.appInfo.xingtuEnable && this.xingTuEnvId
        },
        variables() {
            return _.get(this.appInfo, 'businessEnv.variables', [])
        },
        xingtuInfo() {
            return this.current.xingtuInfo || {}
        },
    },
    watch: {
        'apiParamObj.type'(val) {
            if (this.varObj.optBool && this.varObj.optType !== '编辑') {
                // this.$refs.form && this.$refs.form.resetFields()
                this.$emit('updateApiParamObj', {
                    isOffline: this.apiParamObj.isOffline,
                })
            }
            if (val === 'xingTuApi') {
                // 直接通过路由访问时由于数据未加载完成导致加载列表错误
                setTimeout(() => {
                    if (this.appInfo.xingtuEnable) {
                        if (this.xingTuEnvId) {
                            this.initMipApi()
                        } else {
                            const { businessEnv = {} } = this.appInfo
                            const { category } = businessEnv
                            const envMap = {
                                dev: '开发环境',
                                prod: '生产',
                                test: '测试',
                                beta: '预发布',
                            }
                            this.$message.error(`请完成${envMap[category] || '该'}环境下的环境变量【集成开放平台域名】的值`)
                        }
                    } else {
                        this.$message.error('请先开通集成开放平台对接')
                    }
                }, 100)
            }
        },
        'apiParamObj.api'(val) {
            if (val && this.varObj.optBool) {
                this.changeMipApiDetail(val).then(() => {
                    this.$nextTick(this.$refs.form.validate)
                })
            }
        },
        businessEnvId() {
            this.initMipApi()
        },
        'varObj.optBool'(val) {
            if (val && this.varObj.optType === '添加') {
                this.$nextTick(() => {
                    this.$refs[this.currentRef].resetFields()
                })
            }
        },
        xingTuEnvId: {
            immediate: true,
            handler(val) {
                this.hasBindingStarMap = !!val
            },
        },
        'apiParamObj.domainVariableKey'() {
            // api 地址的类型切换后，自定选中再失焦，触发校验
            this.$nextTick(() => {
                const { urlInput } = this.$refs
                if (!urlInput) return
                urlInput.focus()
                urlInput.blur()
            })
        },
    },
    mounted() {
        this.submitErrList = []
    },
    methods: {
        ...mapActions(APP_RESOURCE, {
            addServiceGroup: T.ADD_NEW_SERVICE_GROUP,
            editServiceGroup: T.EDIT_NEW_SERVICE_GROUP,
            getService: T.GET_NEW_SERVICE,
            addService: T.ADD_NEW_SERVICE,
            editService: T.EDIT_NEW_SERVICE,
            delService: T.DEL_NEW_SERVICE,
            getObject: T.GET_NEW_OBJECT,
            getObjectDtl: T.GET_NEW_OBJECT_DTL,
        }),
        ...mapActions(STAR_MAP, {
            getMipApiList: GET_MIP_API_LIST,
            getMipApiDetail: GET_MIP_API_DETAIL,
            getStarMapBindingDetail: GET_STAR_MAP_BINDING_DETAIL,
        }),
        initMipApi() {
            if (this.isTenantApp) return
            if (!this.xingtuEnable) return
            const { manageKey = '' } = this.xingtuInfo
            this.contentLoading = true
            this.getMipApiList({
                xingTuEnvId: this.xingTuEnvId,
                manageKey,
            }).finally(() => {
                this.contentLoading = false
            })

            // this.getBindingMsg()
        },
        // getBindingMsg() {
        //     this.getStarMapBindingDetail({
        //         appId: this.$route.params.appId,
        //         envId: this.businessEnvId,
        //     }).then(data => {
        //         this.hasBindingStarMap = !!data.xingTuEnvId
        //     }).catch(err => {
        //         console.log(err)
        //     })
        // },
        add(bool) {
            this.editLoading = true
            this.apiParamObj.isXingTu ? this.submitPlatformService(bool) : this.addServiceFn(bool)
        },
        edit() {
            this.editLoading = true
            this.apiParamObj.isXingTu ? this.submitPlatformService(false, true) : this.editServiceFn()
        },
        guid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
                const r = Math.random() * 16 | 0
                // eslint-disable-next-line no-mixed-operators
                const v = c === 'x' ? r : (r & 0x3 | 0x8)
                return v.toString(16)
            })
        },
        addIdToArr(arr) {
            if (!Array.isArray(arr)) return []
            return arr.map(item => {
                let { fields } = item
                if (Array.isArray(fields)) {
                    fields = this.addIdToArr(fields)
                }
                return {
                    ...item,
                    id: this.guid(),
                    fields,
                }
            })
        },
        async changeMipApiDetail(id) {
            const { $to } = this
            this.contentLoading = true
            const { manageKey = '' } = this.xingtuInfo
            const [err, data] = await $to(this.getMipApiDetail({
                id,
                xingTuEnvId: this.xingTuEnvId,
                manageKey,
            }))
            this.contentLoading = false
            if (err) {
                this.$emit('updateApiParamObj', {})
                throw err
            }
            this.mipApiDetail = data
            const emptyParams = !!data.requestMetadata.independentParam
            const requestMetadata = [{
                ...data.requestMetadata, name: 'postData', title: 'root', type: 'object', handle: emptyParams ? 'noHandle' : 'params', isRoot: true, contentType: data.requestMetadata.dataType,
            }]
            const dataType = data.requestMetadata?.dataType
            if (isParamsType(dataType)) {
                data.requestMetadata = Array.isArray(data.requestMetadata.fields) ? data.requestMetadata.fields.map(fieldTransform) : []
                data.body = {
                    type: 'params',
                    contentType: dataType,
                }
            } else {
                data.requestMetadata = this.formatSchema(this.addIdToArr(requestMetadata))
                data.body = {
                    type: 'object',
                    contentType: dataType,
                }
            }
            data.responseMetadata = {
                dataType: data.responseMetadata.dataType || '',
                dataName: data.responseMetadata.dataName || 'data',
                codeName: data.responseMetadata.codeName || '',
                msgName: data.responseMetadata.msgName || '',
                successCodeValue: data.responseMetadata.successCodeValue || '',
                fields: data.responseMetadata.fields,
            }
            if (['object', 'objectArray'].includes(data.responseMetadata.dataType)) {
                data.responseMetadata.schema = {
                    name: 'root',
                    title: 'root',
                    type: 'object',
                    id: this.guid(),
                    fields: this.addIdToArr(data.responseMetadata.fields),
                }
            }
            data.querys = (data.querys || []).map(item => ({ ...item, sourceType: 'dynamic' }))
            data.headers = (data.headers || []).map(item => ({ ...item, sourceType: 'dynamic' }))
            this.$emit('updateApiParamObj', {
                isNotXingTuApi: this.isNotXingTuApi,
                data,
            })
        },
        formatSchema(schema) {
            return schema.map(item => {
                const result = {
                    id: item.id,
                    name: item.name,
                    type: item.type,
                    title: item.title,
                    remark: item.remark,
                    handle: item.handle || '',
                    disable: !item.isRoot,
                    required: !!item.required,
                    relevanceMsg: {
                        isMatching: false,
                        name: '',
                        title: '',
                    },
                    contentType: item.contentType,
                }
                if (Array.isArray(item.fields) && item.fields.length) {
                    result.fields = this.formatSchema(item.fields)
                }
                return result
            })
        },
        treeSelectSearchFun(value) {
            this.$refs.treeSelect.filterFun(value)
        },
        closeSlider() {
            this.$set(this.varObj, 'optBool', false)
        },
        async addGroupbySelect() {
            try {
                if (!this.addInput) {
                    return
                }
                this.addInput = this.addInput.replace(/\s/g, '')
                await this.addServiceGroup({ title: this.addInput })
                this.addInput = ''
                this.showAddgroup = false
                this.$emit('addGroupBySelectSuccess')
                this.loading.page = false
            } catch (error) {
                this.loading.page = false
                // this.$message.error(error.message)
            }
        },
        validBodyOrQuery(obj) {
            function valid(arr = []) {
                return arr.some(item => !item.key)
            }
            const vm = this
            function validRes(res = {}) {
                res.dataType = res.dataType || ''
                let keys = []
                if ((res.dataType || '').includes('object')) {
                    keys = ['currentPageName', 'totalName', 'isMock']
                } else {
                    vm.apiParamObj.response = vm.apiParamObj.response || {}
                    vm.apiParamObj.response.objectId = ''
                    keys = ['currentPageName', 'totalName', 'objectId', 'objectName', 'isMock']
                }
                return Object.keys(res).some((key, index, arr) => {
                    if (arr.includes('isMock') && !res.isMock && key === 'mockData') {
                        return false
                    }
                    if (keys.includes(key)) {
                        return false
                    }
                    return !res[key]
                })
            }
            const {
                method, body = {}, querys = [], headers = [], response = {},
            } = obj
            const result = []
            if (method === 'get') {
                valid(headers) && result.push('headers')
                valid(querys) && result.push('querys')
                validRes(response) && result.push('response')
            } else {
                this.apiParamObj.querys = []
                const { params = [], object = {} } = body
                if (this.varObj.requestBody === 'postData') {
                    this.apiParamObj.body.params = []
                    const { objectId } = object
                    valid(headers) && result.push('headers')
                    !objectId && result.push('object')
                    validRes(response) && result.push('response')
                } else {
                    this.apiParamObj.body.object = this.apiParamObj.body.object || {}
                    this.apiParamObj.body.object.objectId = ''
                    valid(headers) && result.push('headers')
                    valid(params) && result.push('body')
                    validRes(response) && result.push('response')
                }
            }
            return result
        },

        // 添加/编辑集成开放平台服务
        submitPlatformService(bool, isEdit) {
            Promise.all([this.$refs.platformServiceParams.validate(), this.$refs.form.validate()]).then(() => {
                const params = {
                    headers: this.apiParamObj.headers || [],
                    xingTuApiId: this.apiParamObj.api,
                    isXingTu: this.apiParamObj.isXingTu,
                    groupId: this.apiParamObj.groupId,
                    title: this.apiParamObj.title,
                    url: this.apiParamObj.url,
                    method: this.apiParamObj.method,
                    remark: this.apiParamObj.remark,
                    name: this.apiParamObj.name,
                    isMock: false,
                    version: this.apiParamObj.version,
                    authType: this.apiParamObj.authType,
                }
                params.querys = this.apiParamObj.querys

                if (this.apiParamObj.method === 'get') {
                    params.body = null
                } else {
                    params.body = this.formatSubmitBody(this.apiParamObj.body)
                }
                if (this.submitErrList.length) {
                    const nameStr = this.submitErrList.join(',')
                    this.$message.error(`body的${nameStr}节点的关联对象不能为空！`)
                    this.submitErrList = []
                    return Promise.reject()
                }
                params.response = {
                    dataName: this.apiParamObj.response.dataName,
                    dataType: this.apiParamObj.response.dataType,
                    codeName: this.apiParamObj.response.codeName,
                    successCodeValue: this.apiParamObj.response.successCodeValue,
                    msgName: this.apiParamObj.response.msgName,
                }
                if (Object.values(params.response).filter(i => !i).length) {
                    this.$message.error('请完整填写response内容！')
                    return Promise.reject()
                }
                if (['object', 'objectArray'].includes(params.response.dataType)) {
                    if (!this.apiParamObj.response.objectId) {
                        this.$message.error('response的关联对象不能为空！')
                        return Promise.reject()
                    }
                    params.response.objectId = this.apiParamObj.response.objectId
                }
                // totalName不需要校验
                params.response.totalName = this.apiParamObj.response.totalName
                return Promise.resolve(params)
            }).then(params => {
                const { manageKey = '' } = this.xingtuInfo

                if (isEdit) {
                    return this.editService({
                        serviceId: this.varObj.serviceId,
                        params: {
                            ...params,
                            fromEnvId: this.appInfo.fromEnvId,
                            xingTuEnvId: this.xingTuEnvId,
                            manageKey,
                        },
                    }).finally(() => {
                        this.editLoading = false
                    })
                }
                return this.addService({
                    ...params,
                    fromEnvId: this.appInfo.fromEnvId,
                    xingTuEnvId: this.xingTuEnvId,
                    manageKey,
                }).finally(() => {
                    this.editLoading = false
                })
            }).then(() => {
                this.$message.success(isEdit ? '编辑成功' : '保存成功')
                this.$emit('changeServiceSuccess')

                this.back()

                if (!bool || isEdit) {
                    this.$set(this.varObj, 'optBool', false)
                    return
                }
                this.$refs[this.currentRef].resetFields()
                this.$refs.form.resetFields()
                this.$emit('resetFields')
                this.editLoading = false
                this.$emit('updateApiParamObj', { isNotXingTuApi: this.isNotXingTuApi })
            }).catch(() => {
                this.setResponseCollapse()
                this.scrollToError()
                this.editLoading = false
            })
        },
        // 有错误时，展开返回值的下拉处
        setResponseCollapse() {
            let refName = ''
            if (this.isOffline) {
                refName = 'offlineServiceParams'
            } else if (this.isNotXingTuApi) {
                refName = 'customServiceParams'
            } else {
                refName = 'platformServiceParams'
            }
            const refDom = this.$refs[refName]
            if (refDom) {
                refDom.responseCollapse = false
            }
        },
        formatSubmitBody(body) {
            const { params = [], contentType, type } = body
            const root = params[0]
            if (type === 'params' || isParamsType(contentType)) {
                return {
                    params: params.filter(d => d.handle === 'pair').map(({ handle, ...rest }) => rest),
                    contentType,
                    type: 'params',
                }
            }
            if (root.handle === 'params') {
                if (!root.objectId) {
                    this.submitErrList.push(root.name)
                    return false
                }
                return {
                    type: 'object',
                    object: {
                        objectId: root.objectId,
                    },
                    contentType,
                }
            }
            return {
                type: 'params',
                params: this.handleBodyFields(root.fields),
                contentType,
            }
        },
        handleBodyFields(fields = []) {
            return fields.filter(i => i.handle !== 'noHandle').map(item => {
                if ((item.type === 'object' || item.type === 'objectArray') && !item.objectId) {
                    this.submitErrList.push(item.name)
                }
                const result = {
                    key: item.name,
                    type: item.type,
                    required: !!item.required,
                    sourceType: item.sourceType || 'dynamic',
                }
                if (item.type === 'object' || item.type === 'objectArray') {
                    result.objectId = item.objectId
                }
                return result
            })
        },
        getPageY(el) {
            let p = 0
            while (el.offsetParent) {
                p += el.offsetTop
                el = el.offsetParent
            }
            return p
        },
        scrollToError() {
            const scroller = document.querySelector('.slide-content__inner')
            const el = document.querySelector('.hc-form-item.is-error')
            if (el) {
                const scrollTop = this.getPageY(el)
                scroller && scroller.scrollTo(0, scrollTop - 49)
            }
        },
        // 添加自定义服务
        async addServiceFn(bool) {
            async function requestFn() {
                try {
                    this.loading.dialog = true
                    if (!this.apiParamObj.headers) {
                        this.apiParamObj.headers = []
                    }
                    if (_.isEmpty(this.apiParamObj.body)) {
                        this.apiParamObj.body = null
                    }
                    if (!this.apiParamObj.querys) {
                        this.apiParamObj.querys = []
                    }
                    if (_.isEmpty(this.apiParamObj.response)) {
                        this.apiParamObj.response = null
                    }
                    if (this.isTenantApp) {
                        this.apiParamObj.isTenant = true
                        this.apiParamObj.customizeType = 1
                        this.apiParamObj.customizeField = this.COMMON_APPEND
                    }
                    const { manageKey = '' } = this.xingtuInfo
                    await this.addService({ ...this.clearData(this.apiParamObj), fromEnvId: this.appInfo.fromEnvId, manageKey })
                    this.$emit('changeServiceSuccess')
                    this.back()
                    if (!bool) {
                        this.$set(this.varObj, 'optBool', false)
                    }

                    this.$emit('updateApiParamObj', { isNotXingTuApi: this.isNotXingTuApi, isOffline: this.isOffline })
                    this.loading.dialog = false
                    this.$message.success('保存成功')
                    this.$refs[this.currentRef].resetFields()
                    this.$refs.form.resetFields()
                    this.$emit('resetFields')
                } catch (error) {
                    this.scrollToError()
                    this.loading.dialog = false
                }
            }
            const res = await getFormsValidRes(this.$refs[this.currentRef], this.$refs.form)
            if (res) {
                requestFn.call(this)
            } else {
                this.setResponseCollapse()
                this.scrollToError()
            }
            this.editLoading = false
        },
        // 编辑自定义服务
        async editServiceFn() {
            async function requestFn() {
                try {
                    // this.loading.dialog = true;
                    if (!this.apiParamObj.headers) {
                        this.apiParamObj.headers = []
                    }
                    if (_.isEmpty(this.apiParamObj.body)) {
                        this.apiParamObj.body = null
                    }
                    if (!this.apiParamObj.querys) {
                        this.apiParamObj.querys = []
                    }
                    if (_.isEmpty(this.apiParamObj.response)) {
                        this.apiParamObj.response = null
                    }
                    // const errorList = this.validBodyOrQuery(this.apiParamObj)
                    // const { isOffline } = this.apiParamObj

                    // if (errorList.length) {
                    //     this.loading.dialog = false
                    //     const separator = errorList.length > 1 ? ', ' : ''
                    //     const errorResult = errorList.reduce((pre, current) => {
                    //         if (['body', 'headers', 'querys'].includes(current)) {
                    //             pre.key.push(current)
                    //         }
                    //         if (current === 'response') pre.response = true
                    //         if (current === 'object') pre.object = true
                    //         return pre
                    //     }, { key: [], object: false, response: false })
                    //     this.$message.error(
                    //         `${errorResult.key.length ? `${isOffline ? '入参' : `${errorResult.key.join(',')}`}参数的key不能为空${separator}` : ''}${errorResult.object ? `业务对象不能为空${separator}` : ''}${errorResult.response ? 'response的值不能空' : ''}`
                    //     )
                    //     return
                    // }
                    const { manageKey = '' } = this.xingtuInfo

                    await this.editService({
                        serviceId: this.varObj.serviceId,
                        params: { ...this.clearData(this.apiParamObj), fromEnvId: this.appInfo.fromEnvId, manageKey },
                    })
                    this.$message.success('编辑成功')
                    this.$emit('changeServiceSuccess')
                    this.$set(this.varObj, 'optBool', false)

                    this.back()
                } catch (error) {
                    logger.log(error)
                    // this.$message.error(error.message)
                    this.loading.dialog = false
                }
                this.editLoading = false
            }
            const res = await getFormsValidRes(this.$refs[this.currentRef], this.$refs.form)
            if (res) {
                requestFn.call(this)
            } else {
                this.scrollToError()
            }
            this.editLoading = false
        },

        clearData(apiParamObj) {
            let {
                method, querys, body, response, ...rest // eslint-disable-line
            } = apiParamObj
            if (method === 'get') {
                body = body || {}
                body.type = 'params'
                body.params = []
            }
            if (method === 'post') {
                if (body.type === 'params' && body.object) {
                    body.object.objectId = ''
                }
                if (body.type === 'object' && body.params) {
                    body.params = []
                }
            }
            // let { mockData } = response
            // try {
            //     if (response.isMock) {
            //         while (typeof mockData !== 'object') {
            //             mockData = JSON.parse(mockData)
            //         }
            //         mockData = JSON.stringify(mockData)
            //     }
            // } catch (e) {
            //     // eslint-disable-next-line
            //     // console.log(e)
            // }
            return {
                ...rest,
                method,
                querys,
                body,
                response,
                isMock: response.isMock,
                mockData: response.mockData,
            }
        },

        // 更新当前选中的服务类型
        updateServiceType(type) {
            const defaultMethod = 'get'
            const defaultParamType = 'headers'
            let  isXingTu,
                isOffline,
                paramType,
                method

            switch (type) {
                case 'offlineService':
                    isXingTu = false
                    isOffline = true
                    paramType = 'request'
                    method = 'local'
                    break
                case 'xingTuApi':
                    isXingTu = true
                    isOffline = false
                    break
                default:
                    isXingTu = false
                    isOffline = false
                    break
            }
            this.apiParamObj.isXingTu = isXingTu
            this.apiParamObj.isOffline = isOffline
            this.apiParamObj.method = method || defaultMethod
            this.varObj.paramType = paramType || defaultParamType
            this.apiParamObj.domainVariableKey = isXingTu ? 'sys_mip_env' : 'sys_default_domain'
        },

        onChangeApiParam(val) {
            this.$emit('updateApiParamObj', {
                data: {
                    ...this.apiParamObj,
                    ...val,
                    responseMetadata: this.apiParamObj.response,
                },
            })
        },

        onChangeTempParam(val) {
            if (val) {
                TMP_API_OBJ = val
            }
        },

        onChangeTempBody(val) {
            if (val) {
                TMP_API_BODY = val
            }
        },

        handleAutoGenCode() {
            if ((!this.isNotXingTuApi && !this.apiParamObj.api) || (this.isTenantApp && !this.apiParamObj.isTenant)) return
            if (this.apiParamObj && this.apiParamObj.title && !this.apiParamObj.name) {
                import('pinyin/lib/pinyin').then(({ pinyin }) => {
                    if (this.apiParamObj.name) return // 防止未加载完成时，用户已经输入了应用编码，则不需要自动生成
                    const initialsResult = pinyin(this.apiParamObj.title, {
                        style: pinyin.STYLE_FIRST_LETTER,
                    })

                    this.apiParamObj.name = initialsResult.reduce((acc, item) => `${acc}${item.join('')}`, '')
                })
            }
        },

        validateApiDomainVar(rule, value, callback) {
            // 星图暂时不检查
            if (this.apiParamObj.isXingTu) {
                callback()
                return
            }
            const { domainVariableKey } = this.apiParamObj
            const { variables } = this
            if (domainVariableKey && !variables.find(d => d.variableKey === domainVariableKey)) {
                const { businessEnv = {} } = this.appInfo
                const { category } = businessEnv
                const envMap = {
                    dev: '开发环境',
                    prod: '生产',
                    test: '测试',
                    beta: '预发布',
                }
                callback(new Error(`请先在${envMap[category]}环境中添加变量${domainVariableKey}`))
                return
            }

            // validate url regex
            const r = /^(http|https):\/\/[a-zA-Z0-9]+([-.][a-zA-Z0-9]+)*(:[0-9]{1,5})?(\/.*)?$/i

            if (domainVariableKey && r.test(value)) {
                callback(new Error('请输入相对路径，如：/getUserInfo/{userID}'))
                return
            }

            if (!domainVariableKey && !r.test(value)) {
                callback(new Error('请输入请求的URL地址，如 https://getUserInfo/{userID}'))
                return
            }

            callback()
        },

        back() {
            this.$router.push({
                name: 'ServiceManage',
            })
        },
    },
}
</script>

<style lang="less" scoped>

@deep: ~'>>>';
.padding-32 {
    padding-left: 20px;
}
.title-mixin {
    font-size: 16px;
    font-weight: 400;
    color: #222222;
    line-height: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    margin: 18px 0 18px;
}
.title {
   .title-mixin;
}

@{deep} .hc-input {
    width: 100%;
}
@{deep} .hc-textarea {
    width: 400px;
}
@{deep} .hc-table {
    .hc-input,
    .hc-textarea {
        width: 100%;
    }
}
@{deep} .hc-select input {
    height: 32px;
}
@{deep} .modal-slide .slide-title {
    padding: 16px 20px;
}
.content {
    padding: 1px 16px 16px;
    // max-height: 750px;
    box-sizing: border-box;
    background: #F5F7FA;
}
.add_group {
    padding: 0 12px;
    min-height: 40px;
    width: 100%;
    background-color: #fff;
    position: absolute;
    left: 0;
    bottom: 0;
    & > .hc-row {
        align-items: center;
    }
}

.footer {
    padding: 12px 20px;
    text-align: left;
    background: #fff;
    margin: 0 16px 20px 16px;
    .hc-button {
        padding: 8px 28px;
    }
}
h3.sub_title{
    font-size: 16px;
    font-weight: 400;
    color: #222222;
    margin: 32px 0 16px
}
img.local_tip{
    position: relative;
    top: 3px;
}

@{deep} .hc-form-item.is-required {
    .hc-form-item__label {
        position: relative;
    }
    .hc-form-item__label::before {
        display: none;
    }
    .hc-form-item__label::after {
        content: '*';
        display: inline-block;
        margin-right: 4px;
        width: 6px;
        color: #F54860;
        position: absolute;
        left: -8px;
        top: 2px;
    }

}
@{deep} .hc-form-item__label::before {
    display: none;
}
@{deep}  .hc-form-item__label::after {
    display: none;
    content: '';
    //display: inline-block;
    margin-right: 4px;
    width: 6px;
    color: #F54860;
}
.custom-form--item {
    margin: 18px 0;
}
.multiple-form-item {
    @{deep} .hc-form-item__content {
        display: flex;
        width: calc(100% - 112px);
        align-items: center;

        .hc-select {
            width: 168px;
            margin-right: 8px;
            flex: 0 0 168px;
            position: relative;
            top: 1px;

            .hc-input {
                width: 100%;
            }
        }

        > .hc-input {
            flex: 1 1 auto;
        }
    }

    &.is-error {
        @{deep} .hc-select .hc-input__inner {
            border-color: #DDD;
        }

        @{deep} .hc-form-item__content {
            .hc-select {
                top: 0
            }
        }
    }
}
</style>

<style lang="less">
.deploy-service-box {
    --hc-font-size-base: 12px;

    margin-top: 16px;
    padding: 16px 20px;
    background: #FFFFFF;
    border-radius: 3px;
    opacity: 1;
    background: rgba(255,255,255,1);
    box-shadow: 0 0 2px 0 rgba(0,0,0,0.12);
    width: 100%;

    & + .deploy-service-box {
        margin-top: 16px;
    }

    > h1 {
        font-size: 12px;
        font-weight: 700;
        color: #222;
        margin-bottom: 12px;
        margin-top: 0;
    }

    .row {
        display: flex;

        .hc-form-item {
            width: calc(50% - 44px);
            flex-grow: 0;
            margin-bottom: 12px;

            & + .hc-form-item {
                margin-left: 88px;
            }
        }

        .hc-form-item.block {
            width: 100%;
        }

        .hc-select {
            width: 100%;
        }

        .hc-textarea {
            width: 100%;
        }
    }

    .hc-form-item {
        .hc-input--small {
            font-size: 12px;
        }

        .hc-form-item__label {
            font-size: 12px;
            color: #666;
        }
    }

    .hc-form-item__error {
        padding-top: 0;
    }

    .hc-select {
        .hc-input__suffix {
            display: flex;
            align-items: center;
        }
    }

    table {
        .hc-form-item {
            margin-bottom: 0;
        }
    }

    .hc-icon-question {
        &::before {
            color: transparent;
        }
        background-image: url("../../../assets/img/new-tip.svg");
        background-size: contain;
        background-repeat: no-repeat;
    }

    .object-picker__body {
        font-size: 12px;
        color: #222;
    }

    .empty-tip {
        padding: 24px 12px;
        color: #999999;
        line-height: 20px;
        font-size: 12px;
        text-align: center;
    }
}
</style>
